import { observable, action, computed } from 'mobx';
import { Model, App, ArrayApp, ModelRegistry, AppRegistry } from 'core';

import { ObjToDBId } from 'apps/shipmentQuote/utils';

import { FormStore } from 'libs/forms/app';

import { productQuoteFormConfigNoLabels } from './ProductQuoteFormConfg';

export class ProductQuoteModel extends Model {
  static registryName = 'ProductQuoteModel';
  static ModelProps = {
    for: 'JobSpecModel',
    from: 'RFQModel',
    supplier: 'SupplierModel',
    createdBy: 'SupplierModel',
  };

  @observable cost = 0;
  @observable finalCost = 0;
  @observable currency = '';
  @observable isEstimated = false;
  @observable isInstantQuote = false;
  @observable isVoid = false;
  @observable validUntil = null;

  @observable for;
  @observable from;
  @observable supplier = null;
  @observable createdBy = null;
  @observable createdAt = null;
  // @observable notes = '';

  @computed get unitCost() {
    return this.cost / this.for.quantity;
  }

  @computed get finalUnitCost() {
    return this.finalCost / this.for.quantity;
  }
}
ModelRegistry.add(ProductQuoteModel);

export class ProductQuoteApp extends App {
  static registryName = 'ProductQuoteApp';
  static Model = ProductQuoteModel;
  static AppProps = {
    for: 'JobSpecApp',
    from: 'RFQApp',
    // supplier: SupplierApp,
    // createdBy: SupplierApp,
  };

  @observable lastUnitCost = '';

  @observable submitting = false;
  @observable toAdd = false; // should this ProductQuote be added to the ShipmentQuote after submitting?
  @observable deleting = false;
  @observable deleteInitiated = false;

  get form() {
    if (!this.cachedForm) {
      this.cachedForm = new FormStore(
        this,
        productQuoteFormConfigNoLabels,
        'productQuoteForm',
        false, // autoFocusFirstField
      );
    }
    return this.cachedForm;
  }

  @action SetDeleting = boolVal => {
    this.deleting = boolVal;
  };

  @action SetDeleteInitiated = boolVal => {
    this.deleteInitiated = boolVal;
  };

  @computed get dgraphId() {
    return ObjToDBId(this);
  }

  @action SetJobSpecQuantity = quantity => {
    const { unitCost } = this;
    // eslint-disable-next-line no-param-reassign
    this.for.quantity = quantity;
    this.SetCost(unitCost);
  };

  set quantity(quantity) {
    this.SetJobSpecQuantity(quantity);
  }

  @computed get quantity() {
    return this.for.quantity;
  }

  set unitCost(unitCost) {
    this.lastUnitCost = unitCost;
    this.SetCost(unitCost);
  }

  @computed get unitCost() {
    if (this.cost) {
      return this.cost / this.for.quantity;
    }
    return this.lastUnitCost;
  }

  @action SetCost = unitCost => {
    if (this.for.quantity && unitCost) {
      this.cost = unitCost * this.for.quantity;
    } else {
      this.cost = '';
    }
  };

  @action SetSubmitting = submitting => {
    this.submitting = submitting;
  };

  @action SetToAdd = toAdd => {
    this.toAdd = toAdd;
  };
}
AppRegistry.add(ProductQuoteApp);

export class ProductQuotesArrayApp extends ArrayApp {
  static registryName = 'ProductQuotesArrayApp';
  static ElementApp = ProductQuoteApp;
}
AppRegistry.add(ProductQuotesArrayApp);

export class SupplierModel extends Model {
  static registryName = 'SupplierModel';

  static ModelProps = {
    initiative: 'InitiativeModel',
  };

  @observable id;
  @observable companyName;
  @observable initiative;
  @observable address;
}
ModelRegistry.add(SupplierModel);
